function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { keyFilter } from "./keyfilter";
import { isChecked } from "./util";
import { keyReducer } from "./keyReducer";
export var QueueList = /*#__PURE__*/function () {
  function QueueList() {
    _classCallCheck(this, QueueList);

    _defineProperty(this, "count", 0);

    _defineProperty(this, "queue", null);

    _defineProperty(this, "tail", null);
  }

  _createClass(QueueList, [{
    key: "push",
    value: function push(q) {
      var node = {
        val: q,
        next: null
      };

      if (this.count === 0) {
        this.queue = node;
      } else {
        this.tail.next = node;
      }

      this.tail = node;
      this.count++;
    }
  }, {
    key: "peak",
    value: function peak() {
      var current = this.queue;
      if (this.count === 0) return;
      this.count--;

      if (this.count === 0) {
        this.queue = null;
        this.tail = null;
      } else {
        this.queue = this.queue.next;
      }

      return current;
    }
  }, {
    key: "unshift",
    value: function unshift(q) {
      var node = {
        next: null,
        val: q
      };

      if (this.count === 0) {
        this.queue = node;
        this.tail = node;
      } else {
        var head = this.queue;
        this.queue = node;
        node.next = head;
      }

      this.count++;
    }
  }]);

  return QueueList;
}();
export var createTreeModel = function createTreeModel(_ref) {
  var strict = _ref.strict,
      treeData = _ref.treeData,
      selectedKeys = _ref.selectedKeys,
      checkedKeys = _ref.checkedKeys,
      expandedKeys = _ref.expandedKeys,
      defaultExpandAll = _ref.defaultExpandAll,
      lazy = _ref.lazy,
      header = _ref.header;
  var modelsStack = [];

  var getCurrentModels = function getCurrentModels() {
    return modelsStack[modelsStack.length - 1];
  };

  var openContext = function openContext(models) {
    modelsStack.push(models);
  };

  var closeContext = function closeContext() {
    modelsStack.pop();
  };

  var getModel = function getModel(key) {
    var models = getCurrentModels();
    var model = models[key];

    if (model) {
      return model;
    } else {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn("cannot find model with key: ".concat(key));
      }

      return model;
    }
  };

  var remove = function remove(type, val) {
    switch (type) {
      case 'all':
        treeModel.selectedKeys.delete(val);
        break;

      case 'part':
        treeModel.partialKeys.delete(val);
        break;

      case 'none':
        treeModel.unSelectedKeys.delete(val);
        break;
    }
  };

  var add = function add(type, val) {
    switch (type) {
      case 'all':
        treeModel.selectedKeys.add(val);
        break;

      case 'part':
        treeModel.partialKeys.add(val);
        break;

      case 'none':
        treeModel.unSelectedKeys.add(val);
        break;
    }
  };

  var dfs = function dfs(root, action) {
    var iterator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_) {
      return _;
    };
    var stack = [root];

    while (stack.length > 0) {
      var _m = stack.pop();

      var children = action(_m);
      if (!Array.isArray(children)) break;
      var i = children.length - 1;

      for (; i >= 0; i--) {
        stack.push(iterator(children[i]));
      }
    }
  };

  var trigger = function trigger(action, callback) {
    switch (action.type) {
      case 'checked-one':
        {
          var _model = action.model;
          var newSnapshot = keyReducer(_model.snapshot, {
            type: 'one',
            checked: action.checked,
            currentItem: action.currentItem
          });

          if (newSnapshot !== _model.snapshot) {
            if (!action.assume) {
              var _key = action.currentItem.key;
              var old = _model.snapshot.checkGroup[_model.snapshot.indexMap[_key]];
              remove(old, _key);
              add(newSnapshot.checkGroup[newSnapshot.indexMap[_key]], _key);
              _model.snapshot = newSnapshot;
            }
          }

          callback && callback(_model, {
            target: treeModel.target,
            newSnapshot: newSnapshot
          });
          break;
        }

      case 'checked-all':
        {
          var _model2 = action.model;

          var _newSnapshot = keyReducer(_model2.snapshot, {
            type: 'all',
            checked: action.checked
          });

          if (_newSnapshot !== _model2.snapshot) {
            if (!action.assume) {
              var _model2$snapshot = _model2.snapshot,
                  indexMap = _model2$snapshot.indexMap,
                  checkGroup = _model2$snapshot.checkGroup;
              action.model.treeNode.children.forEach(function (_ref2) {
                var key = _ref2.key;
                var i = indexMap[key];
                var oldC = checkGroup[i];
                var c = _newSnapshot.checkGroup[i];

                if (c !== oldC) {
                  remove(oldC, key);
                  add(action.checked, key);
                }
              });
              _model2.snapshot = _newSnapshot;
            }
          }

          callback && callback(_model2, {
            target: treeModel.target,
            newSnapshot: _newSnapshot
          });
          break;
        }

      case 'expand':
        {
          var _model3 = action.model;

          var _newSnapshot2 = _objectSpread({}, _model3.snapshot);

          var _key2 = action.currentItem.key;
          var index = _newSnapshot2.indexMap[_key2];

          if (index !== undefined && _model3.snapshot.expandGroup[index] !== action.expanded) {
            _newSnapshot2.expandGroup[index] = action.expanded;

            if (!action.assume) {
              if (action.expanded) {
                _newSnapshot2.expandedCount++;
                treeModel.expandedKeys.add(_key2);
              } else {
                _newSnapshot2.expandedCount--;
                treeModel.expandedKeys.delete(_key2);
              }

              _model3.snapshot = _newSnapshot2;
            }
          }

          callback && callback(_model3, {
            target: treeModel.target,
            newSnapshot: _newSnapshot2
          });
          break;
        }

      case 'refresh':
        // 需要调用 combine 才有效
        callback && callback(null, {
          target: undefined
        });
        break;

      case 'select':
        {
          if (!action.assume) {
            if (action.value) {
              var lastSelected = getModel(treeModel.selected);

              if (lastSelected) {
                lastSelected.trigger({
                  type: 'select',
                  currentItem: lastSelected.treeNode,
                  value: false
                });
              }

              if (action.currentItem && treeModel.selected !== action.currentItem.key) {
                treeModel.selected = action.currentItem.key;
                callback && callback(null, {
                  target: undefined
                });
              }
            } else {
              treeModel.selected = String(Date.now());
              callback && callback(null, {
                target: undefined
              });
            }
          }

          break;
        }
    }
  };

  var getChecked = function getChecked(key, isStrictMode) {
    var model = getModel(key);
    var snapshot = model.snapshot;
    var pModel = getModel(model.pKey);
    var checked; // 根节点 最顶层不能继续往上找

    if (pModel !== null && pModel !== void 0 && pModel.snapshot) {
      checked = isChecked(pModel.snapshot.selectedMap[key]);
    } else {
      checked = model.snapshot.checkGroup.filter(function (v) {
        return v === 'all';
      }).length === model.snapshot.checkGroup.length;
    }

    var isLeafNode = snapshot.checkGroup.length === 0; // eslint-disable-next-line no-nested-ternary

    return isLeafNode || isStrictMode ? checked : // 如果不是先计算完子节点，这里 count 判断很危险
    snapshot.count === 0 || snapshot.indeterminate && !checked ? false : true;
  };

  var getSelected = function getSelected(key) {
    return treeModel.selected === key;
  };

  var getExpanded = function getExpanded(key) {
    var model = getModel(key);
    var pModel = getModel(model.pKey);
    return pModel.snapshot.expandGroup[pModel.snapshot.indexMap[key]];
  };

  var canExpand = function canExpand(key) {
    var model = getModel(key);
    return model.pKey !== treeModel.id && model.snapshot.expandGroup.length > 0;
  };

  var getSelectedKeys = function getSelectedKeys(root, isStrictMode) {
    var selectedKeys = [];
    var particalSelectedKeys = [];
    dfs(root, function (m) {
      selectedKeys.push.apply(selectedKeys, _toConsumableArray(Array.from(m.snapshot.selected, function (_ref3) {
        var key = _ref3.key;
        return key;
      })));

      if (!isStrictMode) {
        particalSelectedKeys.push.apply(particalSelectedKeys, _toConsumableArray(Array.from(m.snapshot.partialSelected, function (_ref4) {
          var key = _ref4.key;
          return key;
        })));
      }

      return m.treeNode.children;
    }, function (_ref5) {
      var key = _ref5.key;
      return getModel(key);
    });
    return {
      selectedKeys: selectedKeys,
      particalSelectedKeys: particalSelectedKeys
    };
  };

  var getSelectedNode = function getSelectedNode(root, isStrictMode) {
    var result = [];
    dfs(root, function (m) {
      if (isStrictMode) {
        result.push.apply(result, _toConsumableArray(m.snapshot.selected));
      } else {
        result.push.apply(result, _toConsumableArray(m.snapshot.partialSelected).concat(_toConsumableArray(m.snapshot.selected)));
      }

      return m.treeNode.children;
    }, function (_ref6) {
      var key = _ref6.key;
      return getModel(key);
    });
    return result;
  };

  var chooseNodeStrict = function chooseNodeStrict(key, chooseStatus) {
    var model = getModel(key);

    treeModel._update(model.trigger, [{
      type: 'checked-one',
      checked: chooseStatus,
      currentItem: model.treeNode,
      model: getModel(model.pKey)
    }]);
  };

  var chooseNodeAllChildren = function chooseNodeAllChildren(key, chooseStatus) {
    var model = getModel(key);
    model.dfs(model, function (m) {
      treeModel._update(m.trigger, [{
        type: 'checked-all',
        checked: chooseStatus,
        model: m
      }]);

      return m.treeNode.children;
    }, function (_ref7) {
      var key = _ref7.key;
      return getModel(key);
    });
  };

  var chooseNodeAndComputeParentNode = function chooseNodeAndComputeParentNode(key, chooseStatus) {
    var model = getModel(key);

    treeModel._update(model.trigger, [{
      type: 'checked-one',
      checked: chooseStatus,
      model: getModel(model.pKey),
      currentItem: model.treeNode
    }, propagation]);
  };

  var computeCheckedWithChildren = function computeCheckedWithChildren(snapshot) {
    // eslint-disable-next-line no-nested-ternary
    return snapshot.indeterminate ? 'part' : // eslint-disable-next-line no-nested-ternary
    snapshot.count > 0 && snapshot.count === snapshot.checkGroup.length ? 'all' : snapshot.count === 0 ? 'none' : 'part';
  };

  var computeFilteredKeys = function computeFilteredKeys(model, iterator) {
    var filteredKeys = [];
    treeModel.dfs(model, function (m) {
      if (!m) return [];
      var _m$snapshot = m.snapshot,
          indexMap = _m$snapshot.indexMap,
          checkGroup = _m$snapshot.checkGroup;
      return m.treeNode.children.filter(function (_ref8) {
        var key = _ref8.key;
        var c = checkGroup[indexMap[key]];

        if (c === 'all') {
          filteredKeys.push(key);
        } else if (c === 'part') {
          return true;
        }

        return false;
      });
    }, iterator);
    return filteredKeys;
  };

  var propagation = function propagation(model) {
    var snapshot = model.snapshot,
        treeNode = model.treeNode;
    var checked = computeCheckedWithChildren(snapshot);
    var models = getCurrentModels();
    var pModel = models[model.pKey];

    if (model === treeModel.getRoot()) {
      treeModel._update(model.trigger, [{
        type: 'refresh'
      }]);
    } else if (pModel && pModel.snapshot.checkGroup[pModel.snapshot.indexMap[treeNode.key]] !== checked) {
      treeModel._update(model.trigger, [{
        type: 'checked-one',
        checked: checked,
        model: pModel,
        currentItem: treeNode
      }, propagation], 'before');
    }
  };

  var formatNode = function formatNode(_node, _ref9) {
    var lazy = _ref9.lazy;

    var node = _objectSpread(_objectSpread({}, _node), {}, {
      key: String(_node.key),
      isLoadedChildren: true
    });

    if (node.lineColor === undefined) {
      node.lineColor = 'third';
    }

    if (!Array.isArray(node.children)) {
      node.children = [];
    }

    if (node.selectable === undefined) {
      node.selectable = true;
    }

    if (node.iconColor === undefined) {
      node.iconColor = 'primary';
    }

    if (node.color === undefined) {
      node.color = 'primary';
    }

    if (node.iconSelectActiveColor === undefined) {
      node.iconSelectActiveColor = 'branding';
    }

    if (node.titleSelectActiveColor === undefined) {
      node.titleSelectActiveColor = 'branding';
    }

    if (node.useEllipsis !== undefined) {
      node.useEllipsis = Boolean(node.useEllipsis);
    }

    node.disabled = Boolean(node.disabled);

    if (node.loadData !== undefined && typeof node.loadData !== 'function') {
      node.loadData = undefined;
    }

    if (node.children.length > 0) {
      var children = node.loadData ? [] : _toConsumableArray(node.children);
      node.children = children;
    }

    node.isLoadedChildren = !(lazy || node.loadData);
    var models = getCurrentModels();

    if (process.env.NODE_ENV === 'development') {
      if (models[node.key]) {
        // eslint-disable-next-line no-console
        console.warn('duplicate key', _node);
      }
    }

    while (models[node.key]) {
      node.key += '-i';
    }

    return node;
  };

  var k = {
    restDefaultKeys: [],
    restExpandedKeys: []
  };

  var initialize = function initialize(pKey, treeNode, checkedKeys, expandedKeys, level, options) {
    var key = treeNode.key;
    var lazy = options.lazy,
        defaultExpandAll = options.defaultExpandAll,
        isStrictMode = options.strict;
    treeNode.children.forEach(function (childNode, index) {
      // format treeNode 不跟已存在节点重复key
      var node = formatNode(childNode, {
        lazy: lazy
      });
      treeModel.registNode(node.key, true);
      treeNode.children[index] = node;
    });

    var _keyFilter = keyFilter({
      pKey: pKey,
      selectedKeys: checkedKeys,
      expandedKeys: expandedKeys,
      defaultExpandAll: defaultExpandAll,
      source: treeNode.children
    }),
        _keyFilter2 = _slicedToArray(_keyFilter, 3),
        snapshot = _keyFilter2[0],
        _restDefaultKeys = _keyFilter2[1],
        _restExpandedKeys = _keyFilter2[2];

    k.restDefaultKeys = _restDefaultKeys;
    k.restExpandedKeys = _restExpandedKeys;
    var model = createModel(pKey, level, snapshot, treeNode);
    treeModel.registNode(key, model);

    if (!isStrictMode) {
      // 全选自己，向上传 part，自身的checked 值需要从父节点获取
      var _models = getCurrentModels();

      var pModel = _models[pKey]; // 根节点不存在

      if (pModel && isChecked(pModel.snapshot.selectedMap[key])) {
        model.snapshot = keyReducer(snapshot, {
          type: 'all',
          checked: 'all'
        });
        propagation(pModel);
      }
    }

    model.snapshot.selected.forEach(function (_ref10) {
      var key = _ref10.key;
      treeModel.selectedKeys.add(key);
    });
    if (options.until === key) return;

    treeModel._update(initializeChildren, [treeNode, level, options, k]);
  };

  var initializeChildren = function initializeChildren(treeNode, level, options, k) {
    var _iterator = _createForOfIteratorHelper(treeNode.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var childNode = _step.value;
        initialize(treeNode.key, childNode, k.restDefaultKeys, k.restExpandedKeys, level + 1, options);

        if (childNode.key === options.until) {
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var updateNode = function updateNode(model, treeNode, defaultExpandAll) {
    var snapshot = keyReducer(model.snapshot, {
      type: 'clone',
      currentItem: treeNode,
      expanded: function expanded(key) {
        return defaultExpandAll || treeModel.expandedKeys.has(key);
      }
    });
    treeNode.isLoadedChildren = model.treeNode.isLoadedChildren;
    var newModel = createModel(model.pKey, model.level, snapshot, treeNode);
    return newModel;
  };

  var patch = function patch(pKey, oldNode, newNode, options) {
    var newModels = {};
    var defaultExpandAll = options.defaultExpandAll,
        expandedKeys = options.expandedKeys,
        checkedKeys = options.checkedKeys,
        isStrictMode = options.strict;
    var unUsedModel = {};
    var models = getCurrentModels();

    var compare = function compare(pKey, oldTreeData, newTreeData, level) {
      var i = 0;
      var j = 0;
      var last = undefined;

      while (i < oldTreeData.length || j < newTreeData.length) {
        if (!newTreeData[j]) {
          // 新的先结束 移除
          break;
        }

        var oldTreeNode = oldTreeData[i];
        var newTreeNode = newTreeData[j];

        if (last !== j) {
          openContext(newModels);
          newTreeNode = formatNode(newTreeData[j], {
            lazy: options.lazy && newTreeData[j].key !== '#__root__#'
          });
          closeContext();
          last = j; // 同步

          newTreeData[j] = newTreeNode;
        }

        if (oldTreeNode && oldTreeNode.key === newTreeNode.key) {
          // 更新节点
          var _key3 = oldTreeNode.key;
          var _model4 = models[_key3];
          newModels[_key3] = updateNode(_model4, newTreeNode, defaultExpandAll);

          treeModel._update(compare, [_key3, oldTreeNode.children, newTreeNode.children, level + 1]);

          i++;
          j++;
        } else {
          var _model5 = unUsedModel[newTreeNode.key];

          if (_model5) {
            var _newTreeNode = newTreeNode,
                _key4 = _newTreeNode.key;
            var newModel = updateNode(_model5, newTreeNode, defaultExpandAll);
            newModel.pKey = pKey;
            newModel.level = level;
            newModels[_key4] = newModel;

            treeModel._update(compare, [_key4, _model5.treeNode.children, newTreeNode.children, level + 1]);

            unUsedModel[newTreeNode.key] = undefined;
            j++;
            continue;
          } else {
            if (!oldTreeNode) {
              // 新增 new key 或者移动的key
              // 在当前的node 加入，之后的node删除。节点默认可重复。
              // 部分比较，newsModel key 会重复
              openContext(newModels);
              initialize(pKey, newTreeNode, checkedKeys, expandedKeys, level, {
                lazy: options.lazy,
                defaultExpandAll: defaultExpandAll,
                strict: isStrictMode
              });

              if (pKey !== treeModel.id) {
                propagation(getModel(pKey));
              }

              closeContext();
              j++;
              continue;
            }
          }

          i++;
          var oldModel = models[oldTreeNode.key];
          dfs(oldModel, function (m) {
            unUsedModel[m.treeNode.key] = m;
            return m.treeNode.children;
          }, function (_ref11) {
            var key = _ref11.key;
            return getModel(key);
          });
        }
      }

      while (i < oldTreeData.length) {
        // 新的先结束 移除
        var _model6 = models[oldTreeData[i].key];
        dfs(_model6, function (m) {
          unUsedModel[m.treeNode.key] = m;
          return m.treeNode.children;
        }, function (_ref12) {
          var key = _ref12.key;
          return getModel(key);
        });
        i++;
      }
    };

    compare(pKey, oldNode, newNode, 0);

    treeModel._run(function () {
      var restModel = Object.keys(treeModel.models).reduce(function (res, key) {
        var m = treeModel.models[key]; // patch 部分 里面有没有的节点

        if (!(key in unUsedModel)) {
          res[key] = m;
        }

        return res;
      }, {});
      var models = Object.assign(restModel, newModels);
      closeContext();
      openContext(models);
      treeModel.models = models;
      treeModel._rawData = newNode;
    });
  };

  var createModel = function createModel(pKey, level, snapshot, treeNode) {
    return Object.assign(Object.create(baseMethods), {
      pKey: pKey,
      level: level,
      snapshot: snapshot,
      treeNode: treeNode,
      layout: {
        height: 0,
        childrenHeight: 0
      }
    });
  };

  var baseMethods = {
    trigger: trigger,
    getChecked: getChecked,
    getSelected: getSelected,
    getSelectedKeys: getSelectedKeys,
    getSelectedNode: getSelectedNode,
    dfs: dfs,
    getExpanded: getExpanded,
    canExpand: canExpand,
    remove: remove,
    add: add,
    chooseNodeStrict: chooseNodeStrict,
    chooseNodeAllChildren: chooseNodeAllChildren,
    chooseNodeAndComputeParentNode: chooseNodeAndComputeParentNode,
    getModel: getModel,
    initialize: initialize,
    getCurrentModels: getCurrentModels,
    openContext: openContext,
    closeContext: closeContext,
    patch: patch,
    formatNode: formatNode,
    computeCheckedWithChildren: computeCheckedWithChildren,
    createModel: createModel,
    computeFilteredKeys: computeFilteredKeys
  };

  var treeModel = _objectSpread({
    _rawData: null,
    id: 'tree-' + Date.now(),
    expandedKeys: new Set(),
    selectedKeys: new Set(),
    partialKeys: new Set(),
    unSelectedKeys: new Set(),
    selected: '',
    _queue: new QueueList(),
    models: {},
    flattenTree: [],
    target: undefined,
    delayFunction: [],
    isRoot: function isRoot(key) {
      return key === '#__root__#';
    },
    isLeaf: function isLeaf(model) {
      return model.treeNode.children.length === 0;
    },
    getRoot: function getRoot() {
      return treeModel.models['#__root__#'];
    },
    registNode: function registNode(key, model) {
      var models = getCurrentModels();
      models[key] = model;
    },
    _update: function _update(fn, parameters) {
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'after';

      if (position === 'after') {
        treeModel._queue.push({
          fn: fn,
          parameters: parameters
        });
      } else if (position === 'before') {
        treeModel._queue.unshift({
          fn: fn,
          parameters: parameters
        });
      }
    },
    _run: function _run(callback) {
      var s;

      while (s = treeModel._queue.peak()) {
        var _s$val;

        var pa = (_s$val = s.val) === null || _s$val === void 0 ? void 0 : _s$val.parameters;

        try {
          if (pa) {
            var _s$val2;

            (_s$val2 = s.val).fn.apply(_s$val2, _toConsumableArray(pa));
          } else {
            s.val.fn();
          }
        } catch (_unused) {}
      }

      callback && callback();
      k.restDefaultKeys = [];
      k.restExpandedKeys = [];
      treeModel.target = undefined;
    },
    _runDelayFunction: function _runDelayFunction() {
      treeModel.delayFunction.forEach(function (_ref13) {
        var fn = _ref13.fn,
            parameters = _ref13.parameters;

        if (parameters) {
          fn.apply(void 0, _toConsumableArray(parameters));
        } else {
          fn();
        }
      });
      treeModel.delayFunction.length = 0;
    }
  }, baseMethods);

  openContext(treeModel.models);
  var rawRootNode = {
    key: '#__root__#',
    children: treeData,
    icon: header.icon,
    title: header.title,
    color: header.color,
    iconColor: header.iconColor,
    useEllipsis: header.useEllipsis
  };
  initialize(treeModel.id, formatNode(rawRootNode, {
    lazy: false
  }), checkedKeys, expandedKeys, -1, {
    lazy: lazy,
    defaultExpandAll: defaultExpandAll,
    strict: strict
  });
  treeModel.selected = String(selectedKeys[0]);

  treeModel._run(function () {
    treeModel._rawData = [rawRootNode];
  });

  var _iterator2 = _createForOfIteratorHelper(k.restDefaultKeys),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _m2 = _step2.value;
      treeModel.selectedKeys.add(_m2);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(expandedKeys),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _m3 = _step3.value;
      treeModel.expandedKeys.add(_m3);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var _iterator4 = _createForOfIteratorHelper(k.restExpandedKeys),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _m4 = _step4.value;
      treeModel.expandedKeys.add(_m4);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  k.restDefaultKeys = [];
  k.restExpandedKeys = [];
  {
    var _model7 = treeModel.getRoot();

    _model7.getExpanded = function () {
      return false;
    };

    _model7.getChecked = function () {
      var root = treeModel.getRoot();
      var checked = computeCheckedWithChildren(root.snapshot);
      return checked === 'all';
    };
  }
  return treeModel;
};